<template>
    <div class="country-code-selector">
        <div class="selector-trigger" :class="{ 'selector-open': isOpen, 'selector-error': error }"
            @click="toggleDropdown">
            <div class="selected-option">
                <span class="flag">{{ selectedCountry.flag }}</span>
                <span class="code">+{{ selectedCountry.code }}</span>
                <span class="arrow">▼</span>
            </div>
        </div>

        <div v-if="isOpen" class="dropdown-menu">
            <div class="search-box">
                <input ref="searchInput" v-model="searchQuery" type="text" placeholder="Buscar país..."
                    class="search-input" @input="filterCountries">
            </div>

            <div class="country-list">
                <div v-for="(country,index ) in filteredCountries" :key="country.code+ ' '+index" class="country-option"
                    :class="{ 'selected': country.code === selectedCountry.code }" @click="selectCountry(country)">
                    <span class="flag">{{ country.flag }}</span>
                    <span class="name">{{ country.name }}</span>
                    <span class="code">+{{ country.code }}</span>
                </div>
            </div>
        </div>

        <!-- Overlay para cerrar al hacer click fuera -->
        <div v-if="isOpen" class="dropdown-overlay" @click="closeDropdown"></div>
    </div>
</template>

<script>
export default {
    name: 'CountryCodeSelector',

    props: {
        value: {
            type: String,
            default: '52' // México por defecto
        },
        error: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isOpen: false,
            searchQuery: '',
            selectedCountry: {},
            countries: [
                { "code": "52", "name": "México", "flag": "🇲🇽" },
                { "code": "1", "name": "Estados Unidos", "flag": "🇺🇸" },
                { "code": "93", "name": "Afganistán", "flag": "🇦🇫" },
                { "code": "355", "name": "Albania", "flag": "🇦🇱" },
                { "code": "49", "name": "Alemania", "flag": "🇩🇪" },
                { "code": "376", "name": "Andorra", "flag": "🇦🇩" },
                { "code": "244", "name": "Angola", "flag": "🇦🇴" },
                { "code": "1264", "name": "Anguila", "flag": "🇦🇮" },
                { "code": "672", "name": "Antártida", "flag": "🇦🇶" },
                { "code": "1268", "name": "Antigua y Barbuda", "flag": "🇦🇬" },
                { "code": "966", "name": "Arabia Saudita", "flag": "🇸🇦" },
                { "code": "213", "name": "Argelia", "flag": "🇩🇿" },
                { "code": "54", "name": "Argentina", "flag": "🇦🇷" },
                { "code": "374", "name": "Armenia", "flag": "🇦🇲" },
                { "code": "297", "name": "Aruba", "flag": "🇦🇼" },
                { "code": "61", "name": "Australia", "flag": "🇦🇺" },
                { "code": "43", "name": "Austria", "flag": "🇦🇹" },
                { "code": "994", "name": "Azerbaiyán", "flag": "🇦🇿" },
                { "code": "1242", "name": "Bahamas", "flag": "🇧🇸" },
                { "code": "973", "name": "Baréin", "flag": "🇧🇭" },
                { "code": "880", "name": "Bangladés", "flag": "🇧🇩" },
                { "code": "1246", "name": "Barbados", "flag": "🇧🇧" },
                { "code": "32", "name": "Bélgica", "flag": "🇧🇪" },
                { "code": "501", "name": "Belice", "flag": "🇧🇿" },
                { "code": "229", "name": "Benín", "flag": "🇧🇯" },
                { "code": "1441", "name": "Bermudas", "flag": "🇧🇲" },
                { "code": "375", "name": "Bielorrusia", "flag": "🇧🇾" },
                { "code": "95", "name": "Birmania", "flag": "🇲🇲" },
                { "code": "591", "name": "Bolivia", "flag": "🇧🇴" },
                { "code": "387", "name": "Bosnia y Herzegovina", "flag": "🇧🇦" },
                { "code": "267", "name": "Botsuana", "flag": "🇧🇼" },
                { "code": "55", "name": "Brasil", "flag": "🇧🇷" },
                { "code": "673", "name": "Brunéi", "flag": "🇧🇳" },
                { "code": "359", "name": "Bulgaria", "flag": "🇧🇬" },
                { "code": "226", "name": "Burkina Faso", "flag": "🇧🇫" },
                { "code": "257", "name": "Burundi", "flag": "🇧🇮" },
                { "code": "975", "name": "Bután", "flag": "🇧🇹" },
                { "code": "238", "name": "Cabo Verde", "flag": "🇨🇻" },
                { "code": "855", "name": "Camboya", "flag": "🇰🇭" },
                { "code": "237", "name": "Camerún", "flag": "🇨🇲" },
                { "code": "1", "name": "Canadá", "flag": "🇨🇦" },
                { "code": "235", "name": "Chad", "flag": "🇹🇩" },
                { "code": "56", "name": "Chile", "flag": "🇨🇱" },
                { "code": "86", "name": "China", "flag": "🇨🇳" },
                { "code": "357", "name": "Chipre", "flag": "🇨🇾" },
                { "code": "379", "name": "Ciudad del Vaticano", "flag": "🇻🇦" },
                { "code": "57", "name": "Colombia", "flag": "🇨🇴" },
                { "code": "269", "name": "Comoras", "flag": "🇰🇲" },
                { "code": "850", "name": "Corea del Norte", "flag": "🇰🇵" },
                { "code": "82", "name": "Corea del Sur", "flag": "🇰🇷" },
                { "code": "225", "name": "Costa de Marfil", "flag": "🇨🇮" },
                { "code": "506", "name": "Costa Rica", "flag": "🇨🇷" },
                { "code": "385", "name": "Croacia", "flag": "🇭🇷" },
                { "code": "53", "name": "Cuba", "flag": "🇨🇺" },
                { "code": "599", "name": "Curazao", "flag": "🇨🇼" },
                { "code": "45", "name": "Dinamarca", "flag": "🇩🇰" },
                { "code": "1767", "name": "Dominica", "flag": "🇩🇲" },
                { "code": "593", "name": "Ecuador", "flag": "🇪🇨" },
                { "code": "20", "name": "Egipto", "flag": "🇪🇬" },
                { "code": "503", "name": "El Salvador", "flag": "🇸🇻" },
                { "code": "971", "name": "Emiratos Árabes Unidos", "flag": "🇦🇪" },
                { "code": "291", "name": "Eritrea", "flag": "🇪🇷" },
                { "code": "421", "name": "Eslovaquia", "flag": "🇸🇰" },
                { "code": "386", "name": "Eslovenia", "flag": "🇸🇮" },
                { "code": "34", "name": "España", "flag": "🇪🇸" },
                
                { "code": "372", "name": "Estonia", "flag": "🇪🇪" },
                { "code": "251", "name": "Etiopía", "flag": "🇪🇹" },
                { "code": "63", "name": "Filipinas", "flag": "🇵🇭" },
                { "code": "358", "name": "Finlandia", "flag": "🇫🇮" },
                { "code": "679", "name": "Fiyi", "flag": "🇫🇯" },
                { "code": "33", "name": "Francia", "flag": "🇫🇷" },
                { "code": "241", "name": "Gabón", "flag": "🇬🇦" },
                { "code": "220", "name": "Gambia", "flag": "🇬🇲" },
                { "code": "995", "name": "Georgia", "flag": "🇬🇪" },
                { "code": "233", "name": "Ghana", "flag": "🇬🇭" },
                { "code": "350", "name": "Gibraltar", "flag": "🇬🇮" },
                { "code": "1473", "name": "Granada", "flag": "🇬🇩" },
                { "code": "30", "name": "Grecia", "flag": "🇬🇷" },
                { "code": "299", "name": "Groenlandia", "flag": "🇬🇱" },
                { "code": "590", "name": "Guadalupe", "flag": "🇬🇵" },
                { "code": "1671", "name": "Guam", "flag": "🇬🇺" },
                { "code": "502", "name": "Guatemala", "flag": "🇬🇹" },
                { "code": "594", "name": "Guayana Francesa", "flag": "🇬🇫" },
                { "code": "44", "name": "Guernsey", "flag": "🇬🇬" },
                { "code": "224", "name": "Guinea", "flag": "🇬🇳" },
                { "code": "240", "name": "Guinea Ecuatorial", "flag": "🇬🇶" },
                { "code": "245", "name": "Guinea-Bisáu", "flag": "🇬🇼" },
                { "code": "592", "name": "Guyana", "flag": "🇬🇾" },
                { "code": "509", "name": "Haití", "flag": "🇭🇹" },
                { "code": "504", "name": "Honduras", "flag": "🇭🇳" },
                { "code": "852", "name": "Hong Kong", "flag": "🇭🇰" },
                { "code": "36", "name": "Hungría", "flag": "🇭🇺" },
                { "code": "91", "name": "India", "flag": "🇮🇳" },
                { "code": "62", "name": "Indonesia", "flag": "🇮🇩" },
                { "code": "964", "name": "Irak", "flag": "🇮🇶" },
                { "code": "98", "name": "Irán", "flag": "🇮🇷" },
                { "code": "353", "name": "Irlanda", "flag": "🇮🇪" },
                { "code": "44", "name": "Isla de Man", "flag": "🇮🇲" },
                { "code": "61", "name": "Isla de Navidad", "flag": "🇨🇽" },
                { "code": "47", "name": "Isla Bouvet", "flag": "🇧🇻" },
                { "code": "354", "name": "Islandia", "flag": "🇮🇸" },
                { "code": "1345", "name": "Islas Caimán", "flag": "🇰🇾" },
                { "code": "61", "name": "Islas Cocos (Keeling)", "flag": "🇨🇨" },
                { "code": "682", "name": "Islas Cook", "flag": "🇨🇰" },
                { "code": "298", "name": "Islas Feroe", "flag": "🇫🇴" },
                { "code": "500", "name": "Islas Malvinas", "flag": "🇫🇰" },
                { "code": "1670", "name": "Islas Marianas del Norte", "flag": "🇲🇵" },
                { "code": "692", "name": "Islas Marshall", "flag": "🇲🇭" },
                { "code": "677", "name": "Islas Salomón", "flag": "🇸🇧" },
                { "code": "1649", "name": "Islas Turcas y Caicos", "flag": "🇹🇨" },
                { "code": "1284", "name": "Islas Vírgenes Británicas", "flag": "🇻🇬" },
                { "code": "1340", "name": "Islas Vírgenes de los Estados Unidos", "flag": "🇻🇮" },
                { "code": "972", "name": "Israel", "flag": "🇮🇱" },
                { "code": "39", "name": "Italia", "flag": "🇮🇹" },
                { "code": "1876", "name": "Jamaica", "flag": "🇯🇲" },
                { "code": "81", "name": "Japón", "flag": "🇯🇵" },
                { "code": "44", "name": "Jersey", "flag": "🇯🇪" },
                { "code": "962", "name": "Jordania", "flag": "🇯🇴" },
                { "code": "7", "name": "Kazajistán", "flag": "🇰🇿" },
                { "code": "254", "name": "Kenia", "flag": "🇰🇪" },
                { "code": "996", "name": "Kirguistán", "flag": "🇰🇬" },
                { "code": "686", "name": "Kiribati", "flag": "🇰🇮" },
                { "code": "965", "name": "Kuwait", "flag": "🇰🇼" },
                { "code": "856", "name": "Laos", "flag": "🇱🇦" },
                { "code": "266", "name": "Lesoto", "flag": "🇱🇸" },
                { "code": "371", "name": "Letonia", "flag": "🇱🇻" },
                { "code": "961", "name": "Líbano", "flag": "🇱🇧" },
                { "code": "231", "name": "Liberia", "flag": "🇱🇷" },
                { "code": "218", "name": "Libia", "flag": "🇱🇾" },
                { "code": "423", "name": "Liechtenstein", "flag": "🇱🇮" },
                { "code": "370", "name": "Lituania", "flag": "🇱🇹" },
                { "code": "352", "name": "Luxemburgo", "flag": "🇱🇺" },
                { "code": "853", "name": "Macao", "flag": "🇲🇴" },
                { "code": "389", "name": "Macedonia del Norte", "flag": "🇲🇰" },
                { "code": "261", "name": "Madagascar", "flag": "🇲🇬" },
                { "code": "60", "name": "Malasia", "flag": "🇲🇾" },
                { "code": "265", "name": "Malaui", "flag": "🇲🇼" },
                { "code": "960", "name": "Maldivas", "flag": "🇲🇻" },
                { "code": "223", "name": "Malí", "flag": "🇲🇱" },
                { "code": "356", "name": "Malta", "flag": "🇲🇹" },
                { "code": "212", "name": "Marruecos", "flag": "🇲🇦" },
                { "code": "596", "name": "Martinica", "flag": "🇲🇶" },
                { "code": "230", "name": "Mauricio", "flag": "🇲🇺" },
                { "code": "222", "name": "Mauritania", "flag": "🇲🇷" },
                { "code": "262", "name": "Mayotte", "flag": "🇾🇹" },
                { "code": "691", "name": "Micronesia", "flag": "🇫🇲" },
                { "code": "373", "name": "Moldavia", "flag": "🇲🇩" },
                { "code": "377", "name": "Mónaco", "flag": "🇲🇨" },
                { "code": "976", "name": "Mongolia", "flag": "🇲🇳" },
                { "code": "382", "name": "Montenegro", "flag": "🇲🇪" },
                { "code": "1664", "name": "Montserrat", "flag": "🇲🇸" },
                { "code": "258", "name": "Mozambique", "flag": "🇲🇿" },
                { "code": "264", "name": "Namibia", "flag": "🇳🇦" },
                { "code": "674", "name": "Nauru", "flag": "🇳🇷" },
                { "code": "977", "name": "Nepal", "flag": "🇳🇵" },
                { "code": "505", "name": "Nicaragua", "flag": "🇳🇮" },
                { "code": "227", "name": "Níger", "flag": "🇳🇪" },
                { "code": "234", "name": "Nigeria", "flag": "🇳🇬" },
                { "code": "683", "name": "Niue", "flag": "🇳🇺" },
                { "code": "47", "name": "Noruega", "flag": "🇳🇴" },
                { "code": "687", "name": "Nueva Caledonia", "flag": "🇳🇨" },
                { "code": "64", "name": "Nueva Zelanda", "flag": "🇳🇿" },
                { "code": "968", "name": "Omán", "flag": "🇴🇲" },
                { "code": "31", "name": "Países Bajos", "flag": "🇳🇱" },
                { "code": "92", "name": "Pakistán", "flag": "🇵🇰" },
                { "code": "680", "name": "Palaos", "flag": "🇵🇼" },
                { "code": "970", "name": "Palestina", "flag": "🇵🇸" },
                { "code": "507", "name": "Panamá", "flag": "🇵🇦" },
                { "code": "675", "name": "Papúa Nueva Guinea", "flag": "🇵🇬" },
                { "code": "595", "name": "Paraguay", "flag": "🇵🇾" },
                { "code": "51", "name": "Perú", "flag": "🇵🇪" },
                { "code": "689", "name": "Polinesia Francesa", "flag": "🇵🇫" },
                { "code": "48", "name": "Polonia", "flag": "🇵🇱" },
                { "code": "351", "name": "Portugal", "flag": "🇵🇹" },
                { "code": "1", "name": "Puerto Rico", "flag": "🇵🇷" },
                { "code": "974", "name": "Qatar", "flag": "🇶🇦" },
                { "code": "44", "name": "Reino Unido", "flag": "🇬🇧" },
                { "code": "236", "name": "República Centroafricana", "flag": "🇨🇫" },
                { "code": "420", "name": "República Checa", "flag": "🇨🇿" },
                { "code": "243", "name": "República Democrática del Congo", "flag": "🇨🇩" },
                { "code": "1809", "name": "República Dominicana", "flag": "🇩🇴" },
                { "code": "262", "name": "Reunión", "flag": "🇷🇪" },
                { "code": "250", "name": "Ruanda", "flag": "🇷🇼" },
                { "code": "40", "name": "Rumania", "flag": "🇷🇴" },
                { "code": "7", "name": "Rusia", "flag": "🇷🇺" },
                { "code": "685", "name": "Samoa", "flag": "🇼🇸" },
                { "code": "1684", "name": "Samoa Americana", "flag": "🇦🇸" },
                { "code": "1869", "name": "San Cristóbal y Nieves", "flag": "🇰🇳" },
                { "code": "378", "name": "San Marino", "flag": "🇸🇲" },
                { "code": "1599", "name": "San Martín (parte neerlandesa)", "flag": "🇸🇽" },
                { "code": "508", "name": "San Pedro y Miquelón", "flag": "🇵🇲" },
                { "code": "1784", "name": "San Vicente y las Granadinas", "flag": "🇻🇨" },
                { "code": "290", "name": "Santa Elena", "flag": "🇸🇭" },
                { "code": "1758", "name": "Santa Lucía", "flag": "🇱🇨" },
                { "code": "239", "name": "Santo Tomé y Príncipe", "flag": "🇸🇹" },
                { "code": "221", "name": "Senegal", "flag": "🇸🇳" },
                { "code": "381", "name": "Serbia", "flag": "🇷🇸" },
                { "code": "248", "name": "Seychelles", "flag": "🇸🇨" },
                { "code": "232", "name": "Sierra Leona", "flag": "🇸🇱" },
                { "code": "65", "name": "Singapur", "flag": "🇸🇬" },
                { "code": "963", "name": "Siria", "flag": "🇸🇾" },
                { "code": "252", "name": "Somalia", "flag": "🇸🇴" },
                { "code": "94", "name": "Sri Lanka", "flag": "🇱🇰" },
                { "code": "27", "name": "Sudáfrica", "flag": "🇿🇦" },
                { "code": "249", "name": "Sudán", "flag": "🇸🇩" },
                { "code": "211", "name": "Sudán del Sur", "flag": "🇸🇸" },
                { "code": "46", "name": "Suecia", "flag": "🇸🇪" },
                { "code": "41", "name": "Suiza", "flag": "🇨🇭" },
                { "code": "597", "name": "Surinam", "flag": "🇸🇷" },
                { "code": "268", "name": "Suazilandia", "flag": "🇸🇿" },
                { "code": "66", "name": "Tailandia", "flag": "🇹🇭" },
                { "code": "886", "name": "Taiwán", "flag": "🇹🇼" },
                { "code": "255", "name": "Tanzania", "flag": "🇹🇿" },
                { "code": "992", "name": "Tayikistán", "flag": "🇹🇯" },
                { "code": "670", "name": "Timor Oriental", "flag": "🇹🇱" },
                { "code": "228", "name": "Togo", "flag": "🇹🇬" },
                { "code": "690", "name": "Tokelau", "flag": "🇹🇰" },
                { "code": "676", "name": "Tonga", "flag": "🇹🇴" },
                { "code": "1868", "name": "Trinidad y Tobago", "flag": "🇹🇹" },
                { "code": "216", "name": "Túnez", "flag": "🇹🇳" },
                { "code": "993", "name": "Turkmenistán", "flag": "🇹🇲" },
                { "code": "90", "name": "Turquía", "flag": "🇹🇷" },
                { "code": "688", "name": "Tuvalu", "flag": "🇹🇻" },
                { "code": "380", "name": "Ucrania", "flag": "🇺🇦" },
                { "code": "256", "name": "Uganda", "flag": "🇺🇬" },
                { "code": "598", "name": "Uruguay", "flag": "🇺🇾" },
                { "code": "998", "name": "Uzbekistán", "flag": "🇺🇿" },
                { "code": "678", "name": "Vanuatu", "flag": "🇻🇺" },
                { "code": "58", "name": "Venezuela", "flag": "🇻🇪" },
                { "code": "84", "name": "Vietnam", "flag": "🇻🇳" },
                { "code": "681", "name": "Wallis y Futuna", "flag": "🇼🇫" },
                { "code": "967", "name": "Yemen", "flag": "🇾🇪" },
                { "code": "253", "name": "Yibuti", "flag": "🇩🇯" },
                { "code": "260", "name": "Zambia", "flag": "🇿🇲" },
                { "code": "263", "name": "Zimbabue", "flag": "🇿🇼" }
            ]
        };
    },

    computed: {
        filteredCountries() {
            if (!this.searchQuery) {
                return this.countries;
            }

            const query = this.searchQuery.toLowerCase();
            return this.countries.filter(country =>
                country.name.toLowerCase().includes(query) ||
                country.code.includes(query) ||
                country.flag.toLowerCase().includes(query)
            );
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.findCountryByCode(newVal);
            }
        }
    },

    mounted() {
        this.findCountryByCode(this.value);
    },

    methods: {
        findCountryByCode(code) {
            const country = this.countries.find(c => c.code === code) || this.countries[1]; // México por defecto
            this.selectedCountry = { ...country };
        },

        toggleDropdown() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.$refs.searchInput?.focus();
                });
            }
        },

        closeDropdown() {
            this.isOpen = false;
            this.searchQuery = '';
        },

        selectCountry(country) {
            this.selectedCountry = { ...country };
            this.$emit('input', country.code);
            this.$emit('change', {
                code: country.code,
                name: country.name,
                flag: country.flag
            });
            this.closeDropdown();
        },

        filterCountries() {
            // La computada filteredCountries se actualiza automáticamente
        }
    }
};
</script>

<style scoped>
.country-code-selector {
    position: relative;
    display: inline-block;
    min-width: 120px;
}

.selector-trigger {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 8px 12px;
    cursor: pointer;
    background: white;
    transition: all 0.3s ease;
}

.selector-trigger:hover {
    border-color: #c0c4cc;
}

.selector-open {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.selector-error {
    border-color: #f56c6c;
}

.selected-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.flag {
    font-size: 16px;
}

.code {
    font-weight: 500;
    color: #303133;
}

.arrow {
    font-size: 10px;
    color: #c0c4cc;
    transition: transform 0.3s ease;
}

.selector-open .arrow {
    transform: rotate(180deg);
}

.dropdown-menu {
    position: fixed;
    background: white;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    z-index: 1001;
    margin-top: 4px;
    max-height: 300px;
    overflow: hidden;
}

.search-box {
    padding: 8px;
    border-bottom: 1px solid #ebeef5;
}

.search-input {
    width: 100%;
    padding: 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    outline: none;
}

.search-input:focus {
    border-color: #409eff;
}

.country-list {
    max-height: 250px;
    overflow-y: auto;
    z-index: 4000;
}

.country-option {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    gap: 8px;
    transition: background-color 0.3s ease;
}

.country-option:hover {
    background-color: #f5f7fa;
}

.country-option.selected {
    background-color: #ecf5ff;
    color: #409eff;
}

.country-option .name {
    flex: 1;
    text-align: left;
}

.country-option .code {
    color: #909399;
    font-size: 12px;
}

.dropdown-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
}
</style>